export const USER_GRADE = {
  GRADUATE: 'Consultant - Graduate',
  CONSULTANT: 'Consultant'
};
